export const CareNoteTexts = {
  createSuccess: 'Care note added!',
  editSuccess: 'Care note updated!',
  error: 'An error occurred. Please try again.',
};
